import React from "react";
import { Link } from "react-router-dom";
import { FaArrowAltCircleLeft } from "react-icons/fa";

const BackBtn = () => {
  return (
    <Link to="/programming">
      <FaArrowAltCircleLeft
        className="backBtn"
        style={{
          color: "#e81c1c",
        }}
      />
    </Link>
  );
};

export default BackBtn;
